module.exports = __webpack_public_path__ + "img/portraits_25_V.0db22381.webp";